export default "__VITE_ASSET__DGjUbyph__"